var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReachNewBrokerages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.892 9.928-1.092-1.09a1.445 1.445 0 0 1 -.419-1.012v-1.278a2.934 2.934 0 0 0 -2.931-2.93h-1.276a1.425 1.425 0 0 1 -1.012-.418l-1.09-1.091a2.934 2.934 0 0 0 -4.144 0l-1.09 1.091a1.425 1.425 0 0 1 -1.012.419h-1.277a2.934 2.934 0 0 0 -2.931 2.93v1.277a1.441 1.441 0 0 1 -.418 1.011l-1.092 1.091a2.934 2.934 0 0 0 0 4.144l1.092 1.09a1.445 1.445 0 0 1 .419 1.012v1.278a2.934 2.934 0 0 0 2.931 2.93h1.276a1.425 1.425 0 0 1 1.012.419l1.09 1.091a2.933 2.933 0 0 0 4.144 0l1.09-1.091a1.425 1.425 0 0 1 1.012-.419h1.277a2.934 2.934 0 0 0 2.931-2.93v-1.278a1.437 1.437 0 0 1 .419-1.011l1.091-1.091a2.934 2.934 0 0 0 0-4.144z",
    fill: "#ffc545"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.172 15.579a.751.751 0 0 1 -.53-1.281l5.658-5.657a.75.75 0 0 1 1.058 1.059l-5.658 5.659a.748.748 0 0 1 -.528.22z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachNewBrokerages);
export default __webpack_public_path__ + "static/media/reach-new-brokerages.bfc465c2a814512b7624cb4d25834746.svg";
export { ForwardRef as ReactComponent };